<template>
  <div class="row">
    <div v-bind:class="propColunas">
      <div v-if="mensagem !== ''" class="alert alert-success alert-dismissible fade show text-center" role="alert">
        <strong>{{ mensagem }}</strong>
      </div>
      <Dialog :id="idDialog" titulo="Plano usuario" ref="dialog" :modal="propModal" :hideHeader="true"
        :noClassFooter="true">

        <div class="">

          <div class="row" style="margin-bottom: 5px">
            <div class="col-sm-12">
              <div class="form-group row">
                <div class="col-sm-12">
                  <h4 class="text-center" style="margin-bottom: 20px">Seus créditos</h4>
                  <h4 class="text-center text-secondary">€ {{ item.credito }}</h4>
                  <p class="text-center" v-if="itemErros.credito.status" style="margin-bottom: 0px">
                    <small class="text-danger">{{ itemErros.credito.mensagem }}</small>
                  </p>
                  <hr style="width:40%;margin-bottom:0px" />
                </div>
              </div>
            </div>
          </div>

          <div class="row" :style="{ display: (propView == 'plano' ? 'block' : 'none') }">
            <div class="col-sm-12">
              <div class="form-group row">
                <div class="col-sm-12">
                  <h4 class="text-center" style="margin-bottom: 20px">Escolha o plano</h4>
                  <Combo :itens="planos" v-model="item.plano" />
                  <p v-if="itemErros.plano.status" style="margin-bottom: 0px">
                    <small class="text-danger">{{ itemErros.plano.mensagem }}</small>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="row" :style="{ display: (propView == 'evento' ? 'block' : 'none') }">
            <div class="col-sm-12" style="margin-bottom: 20px">

              <h4 class="text-center">Compra avulsa</h4>
              <h4 class="text-center text-secondary">{{ this.item.evento.nome }}</h4>
              <h5 class="text-center text-secondary" style="margin-bottom: 10px">
                <small>{{ this.item.evento.data }}</small></h5>
              <p class="text-center">Será descontado € {{ this.item.evento.valor }} dos seus créditos</p>

            </div>
          </div>

          <div class="row" style="margin-top:5px">
            <div class="col-md-12 col-sm-12 text-center">

              <p v-if="item.plano !== '' && item.dataInicio !== '' && validarDataInicio">
                O período do novo plano será do dia <br /><b>{{ formatDate(item.dataInicio) }}</b> á
                <b>{{ formatDate(dateAddDays(item.dataInicio, planosKey[item.plano].duracao)) }}</b>
              </p>

            </div>
          </div>

        </div>

        <template v-slot:rodape>
          <div class="row mb-2">
            <div class="col-md-12 col-sm-12">
              <hr style="width:80%;margin-bottom:10px;margin-top:5px" />
              <div class="d-flex justify-content-center">
                <button type="button" class="btn btn-secondary btn-sm" @click="fechar()">Cancelar</button>
                <button type="button" class="btn btn-success btn-sm" style="margin-left:10px"
                  :style="{ display: (propView == 'plano' ? 'block' : 'none') }" @click="adquirirPlano()">Comprar
                  plano</button>
                <button type="button" class="btn btn-success btn-sm" style="margin-left:10px"
                  :style="{ display: (propView == 'evento' ? 'block' : 'none') }" @click="adquirirEvento()">Comprar
                  evento</button>
              </div>
            </div>
          </div>
        </template>
      </Dialog>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

import Dialog from "../components/Dialog.vue";
import Combo from "../components/Combo.vue";


export default {
  name: "EditPlanoUsuarioPublico",
  components: { Dialog, Combo },
  props: {
    propView: { type: String, default: "plano" },
    propEvento: { type: String, default: "" },
    propModal: { type: Boolean, default: true },
    propColunas: {
      type: Array,
      default: function () {
        return ["col-md-12"];
      },
    },
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    async carregarCreditos() {
      const response = await api.get("/usuario/meus-dados");

      if (response.data.erro == false) {
        this.item.credito = response.data.item.credito;
      }

    },
    async carregarItem() {

      //* Limpa os dados
      this.itemErros = util.errosLimpar(this.itemErros);
      this.item.dataInicio = util.dateToStringUS(new Date());

      this.planos = [];

      var filtros = "";

      if (this.propSite !== "") {
        filtros = "?site=" + this.propSite;
      }

      const response = await api.get("/plano" + filtros);
      api.valid(response.data, this.$router);

      //* Percorre todos os planos
      for (var indicePlano = 0;
        indicePlano < response.data.itens.length;
        indicePlano++) {

        var plano = response.data.itens[indicePlano];

        if (indicePlano == 0) {
          this.item.plano = plano._id;
        }

        this.planos.push({ id: plano._id, nome: plano.nome + " (" + plano.duracao + " dias " + (plano.valor ? " / € " + plano.valor.toString() : "") + ")", plano: plano });

        this.planosKey[plano._id] = plano;

      }

      this.carregarCreditos();

    },
    async carregarItemEvento(evento) {

      //* Limpa os dados
      this.itemErros = util.errosLimpar(this.itemErros);
      this.item.evento = { _id: "", nome: "", data: "", valor: 0 }

      const responseEvento = await api.get("/evento/" + evento._id);
      api.valid(responseEvento.data, this.$router);

      //* Verifica se ocorreu algum erro
      if (!responseEvento.data.erro && responseEvento.data.itens.length > 0) {
        var dadosEvento = responseEvento.data.itens[0];

        this.item.evento._id = dadosEvento._id;
        this.item.evento.nome = dadosEvento.nome;
        this.item.evento.data = dadosEvento.dataDia + "/" + dadosEvento.dataMes + "/" + dadosEvento.dataAno + " " + dadosEvento.dataHora + ":" + dadosEvento.dataMinuto;
        this.item.evento.valor = (dadosEvento.valor ? dadosEvento.valor : 0);

      }

      this.carregarCreditos();

    },
    async adquirirPlano() {

      this.itemErros = util.errosLimpar(this.itemErros);

      //* Envia os dados para a api
      var apiRequest = await api.post("/plano/usuario", {
        usuario: this.propUsuario,
        plano: this.item.plano
      });

      console.log(apiRequest.data);

      //* Verifica se ocorreu algum erro
      if (!apiRequest.data.erro) {

        //* Fecha a janela
        this.$refs.dialog.fechar();
        this.$emit("fechar", this.item);
        
      } else {

        if (apiRequest.data.erros) {
          util.errosProcessar(this.itemErros, apiRequest.data.erros);
        }

      }

    },
    async adquirirEvento() {

      this.itemErros = util.errosLimpar(this.itemErros);

      //* Envia os dados para a api
      var apiRequest = await api.post("/evento/usuario", {
        evento: this.item.evento._id
      });

      //* Verifica se ocorreu algum erro
      if (!apiRequest.data.erro) {

        //* Fecha a janela
        this.$refs.dialog.fechar();
        this.$emit("fechar", this.item);
        this.$emit("comprado", this.item);
        
      } else {

        if (apiRequest.data.erros) {
          util.errosProcessar(this.itemErros, apiRequest.data.erros);
        }

      }

    },
    async enterSalvar(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        this.salvarItem();
      }
    },
    fechar() {
      this.$refs.dialog.fechar();
      this.$emit("fechar");
    },
    abrir() {
      this.$refs.dialog.abrir();

      if (this.propView == "plano") {
        this.carregarItem();
      }

    },
    formatDate(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDate(data);
    },
    dateAddDays(data, days) {
      var date = new Date(data.valueOf());

      if (this.retornaSite() == "7live") {
        days = days + 1
      }

      date.setDate(date.getDate() + days);
      return date;
    }
  },
  async mounted() {

    this.view = this.propView;

    this.idDialog = "dialogEditPlanoUsuarioPublico_" + util.guidGenerator();

  },
  data: function () {
    return {
      item: {
        credito: "",
        plano: "",
        dataInicio: "",
        evento: { _id: "", nome: "", data: "", valor: 0 }
      },
      itemErros: {
        plano: { status: false, mensagem: "" },
        credito: { status: false, mensagem: "" }
      },
      view: "",
      mensagem: "",
      idDialog: "",
      planos: [],
      planosKey: {}
    };
  },
  computed: {
    validarDataInicio: function () {

      var dataInicio = util.parseDateUS(this.item.dataInicio);

      if (util.dateDiffDays(new Date(), dataInicio) >= 0) {
        return true;
      } else {
        return false;
      }

    }
  }
};
</script>

<style></style>
